<template src="./Appointment.html"></template>

<script>
import moment from "moment";
import PatientData from "../../../Patient/PatientData/PatientData.vue";
import mixins from "../../../../../Mixins.js";
export default {
  mixins: [mixins],
  name: "appointment",
  components: {
    PatientData
  },
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      showWebTable: true,
      popupAbsent: false,
      popupCancel: false,
      popupInit: false,
      appointments: [],
      idAppointment: 0,
      showAppointment: true,
      isNewAppointment: false,
      idMedicalRecord: 0,
      showVideo: false,
      roomUrl: "",
    };
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  mounted: function() {
    const vm = this;
    vm.init();
  },
  methods: {
    init() {
      const vm = this;
      vm.getAppointment();
      vm.getCancelAppointment();
    },
    handleResize() {
      const vm = this;
      vm.window.width = window.innerWidth;
      vm.window.height = window.innerHeight;
      if (vm.window.width < 815) {
        vm.showWebTable = false;
      } else {
        vm.showWebTable = true;
      }
    },
    getAppointment() {
      const vm = this;
      const now = moment(new Date());
      var formatDateToBR = moment(String(now)).format("DD/MM/YYYY");
      this.axios
        .get(
          vm.$store.state.filooServer +
            "doctor/appointments?size=50&sort=dateHour,desc",
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function(response) {
          vm.appointments = response.data.content;
          for (let a in vm.appointments) {
            let partsDateHour = vm.appointments[a].dateHour.split(" ");
            vm.appointments[a].hour = partsDateHour[1];
            if(vm.getDay(vm.appointments[a].dateHour) !== formatDateToBR ){
              vm.appointments[a].disabledButton = true;
            } else {
              vm.appointments[a].disabledButton = false;
            }
          }
        });
    },
    //appointments-canceled

    getCancelAppointment() {
      const vm = this;
      this.axios
        .get(vm.$store.state.filooServer + "doctor/appointments-canceled", {
          headers: { Authorization: vm.$session.get("bearer") }
        });
    },

    initMedicalConsultation(medicalRecordId, appointmentId) {
      const vm = this;
      vm.medicalRecordId = medicalRecordId;
      vm.appointmentId = appointmentId;
      vm.popupInit = true;
    },
    clickBtnInitConfirm() {
      const vm = this;
        vm.popupInit = false;
        setTimeout(function () {
        vm.$router.push("/patient-data/" + vm.medicalRecordId);
      }, 300);
    },
    medicalConsult(medRecordId){
      const vm = this;
      vm.$router.push({path:"/patient-data/" + medRecordId, params: {id: medRecordId}});
    },
    cancelMedicalConsultation(appointmentId) {
      const vm = this;
      vm.idAppointment = appointmentId;
      vm.popupCancel = true;
    },
    clickBtnCancelConfirm() {
      const vm = this;
      var appointment = {};
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "doctor/appointments/" +
            vm.idAppointment +
            "/cancel",
          appointment,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          vm.popupCancel = false;
          if (response.status === 200) {
            vm.getAppointment();
            vm.$swal("Sucesso!", "Consulta cancelada", "success");
          } else {
            vm.$swal("Erro ao cancelar", "error");
          }
        })
        .catch(function() {
          vm.$swal("Erro ao cancelar", "error");
        });
    },
    absentPatient(appointmentId) {
      const vm = this;
      vm.idAppointment = appointmentId;
      vm.popupAbsent = true;
    },
    clickBtnAbsentConfirm() {
      const vm = this;
      var appointment = {};
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "doctor/appointments/" +
            vm.idAppointment +
            "/noshow",
          appointment,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          vm.popupAbsent = false;
          if (response.status === 200) {
            vm.getAppointment();
            vm.$swal("Sucesso!", "Consulta cancelada", "success");
          } else {
            vm.$swal("Erro ao cancelar", "error");
          }
        })
        .catch(function() {
          vm.$swal("Erro ao cancelar", "error");
        });
    },
    newAppointment(appointmentId, medicalRecordId) {
      const vm = this;
      vm.idAppointment = appointmentId;
      vm.idMedicalRecord = medicalRecordId;
      vm.showAppointment = false;
      vm.isNewAppointment = true;
    },
    getDay(dateHour) {
      return dateHour.substring(0, 10);
    },
    getHour(dateHour) {
      return dateHour.substring(12, 16);
    }
  }
};
</script>

<style lang="scss" src="./Appointment.scss">
</style>
